import styled from "styled-components";

export const PageCounterStyle = styled.div`
  &.Inactive {
    display: none;
  }
  select {
    padding: 0.4rem 0.1rem;
    border-radius: 5px;
    border: 1px solid #dddddd;
    background-color: unset;
    color: #27548c;
    margin-left: 18px;
    option {
    }
    &:active {
      border: 1px solid #27548c;
      outline: none;
    }
    &:focus-visible {
      border: 1px solid #27548c;
      outline: none;
    }
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;
